var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.dataLoaded !== false)?_c('RouterView',{class:'' + _vm.$store.state.client.name + 'Theme'}):_vm._e(),_c('Loader',{attrs:{"options":_vm.loaderOptions,"loadingText":true,"textLight":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }